import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { cloneDeep } from 'lodash'
import type IStore from './types'
import { sleep } from '@/hooks/use-utils'

const useStore = create(
  devtools<IStore>((set, get) => ({
    categoriesData: undefined,
    setCategoriesData: (data) => set(() => ({ categoriesData: data })),
    locationsData: undefined,
    setLocationsData: (data) => set(() => ({ locationsData: data })),
    residentsData: undefined,
    setResidentsData: (data) => set(() => ({ residentsData: data })),
    campusesData: undefined,
    setCampusesData: (data) => set(() => ({ campusesData: data })),
    activeCategoryFilter: { top: undefined, bottom: undefined },
    setActiveCategoryFilter: (filter, side) =>
      set((state) => {
        const activeCategoryFilter = cloneDeep(state.activeCategoryFilter)
        activeCategoryFilter[side] =
          activeCategoryFilter[side] === filter ? undefined : filter
        return {
          activeCategoryFilter,
        }
      }),
    activeMode: 'basel',
    setActiveMode: (mode) => {
      set(() => ({ activeMode: mode }))
    },
    modals: {
      top: undefined,
      bottom: undefined,
      main: undefined,
    },
    lastModals: {
      top: undefined,
      bottom: undefined,
      main: undefined,
    },
    setModal: async (modal, side) => {
      set((state) => {
        if (!state.modals[side]?.content) return {}
        const lastModals = cloneDeep(state.lastModals)
        lastModals[side] = state.modals[side]
        return {
          lastModals,
        }
      })
      if (get().modals[side]?.content) {
        set((state) => {
          const modals = cloneDeep(state.modals)
          modals[side]!.content = undefined
          return { modals }
        })
        if (modal.content) await sleep(250)
      }
      if (modal.content) {
        set((state) => {
          const modals = cloneDeep(state.modals)
          modals[side] = modal
          return { modals }
        })
      }
    },
    saveModalState: (modalState, side) => {
      set((state) => {
        const modals = cloneDeep(state.modals)
        modals[side]!.state = modalState
        return {
          modals,
        }
      })
    },
    goLastModal: (side) => get().setModal(get().lastModals[side]!, side),
    resetTableState: (side) =>
      set((state) => {
        const modals = cloneDeep(state.modals)
        const activeCategoryFilter = cloneDeep(state.activeCategoryFilter)
        if ((side === 'top' || !side) && modals.top)
          modals.top.content = undefined
        if ((side === 'bottom' || !side) && modals.bottom)
          modals.bottom.content = undefined
        if (modals.main) modals.main.content = undefined
        if (!side) {
          activeCategoryFilter.top = undefined
          activeCategoryFilter.bottom = undefined
        } else {
          activeCategoryFilter[side] = undefined
        }
        return {
          activeMode: 'basel',
          activeCategoryFilter,
          modals,
        }
      }),
    isIdle: false,
    setIsIdle: (flag) => {
      set(() => {
        return {
          isIdle: flag,
        }
      })
    },
    sounds: {},
    setSounds: (sounds) => {
      const newSounds: { [key: string]: HTMLAudioElement } = {}
      sounds.forEach((sound) => {
        const key = Object.keys(sound)[0]
        newSounds[key] = new Audio(require(`@/assets/sounds/${sound[key]}`))
      })
      set(() => {
        return {
          sounds: newSounds,
        }
      })
    },
    availableCategories: [],
    setAvailableCategories: (categories) => {
      set(() => {
        return {
          availableCategories: categories,
        }
      })
    },
  }))
)

export default useStore
